<template>
    <v-card elevation="2" height="100%">
        <v-card-text>
            <h2 class="display-1 mb-4">{{ title }}</h2>
            <v-flex>
                <v-autocomplete
                    @click="maybeGetEmployees"
                    label="Employee"
                    :items="selectableEmployees"
                    item-text="name"
                    item-value="id"
                    v-model="selectedEmployeeID"
                    :loading="apiCallPending"
                    :disabled="apiCallPending"
                    clearable
                ></v-autocomplete>
            </v-flex>
        </v-card-text>
        <v-card-actions>
            <v-layout justify-end>
                <v-btn @click="getCommLogReport" color="primary"> Get {{ title }} </v-btn>
            </v-layout>
        </v-card-actions>
    </v-card>
</template>

<script>
import collectionApi from "@/api/collections";

export default {
    components: {},
    computed: {},
    created() {},
    props: ["title"],
    watch: {},
    data: function () {
        return {
            selectableEmployees: [],
            selectedEmployeeID: null,
            apiCallPending: false,
        };
    },
    computed: {},
    methods: {
        maybeGetEmployees() {
            if (this.selectableEmployees.length === 0) {
                this.apiCallPending = true;
                collectionApi.getEmployees((employees) => {
                    this.selectableEmployees = employees;
                    this.apiCallPending = false;
                });
            }
        },

        getCommLogReport: function () {
            this.$router.push({
                name: "commLogReport",
                query: {
                    employeeID: this.selectedEmployeeID,
                },
            });
        },
    },
};
</script>
